import { useQueryClient } from "@tanstack/react-query";

const useCacheCleaner = (): { clearCache: (prefixes: string[]) => void } => {
	const queryClient = useQueryClient();

	const clearCache = (prefixes: string[]) => {
		prefixes?.forEach((prefix) => {
			queryClient.removeQueries({
				predicate: (query) => (query.queryKey as string[])[0].startsWith(prefix),
			});
		});
	};

	return { clearCache };
};

export default useCacheCleaner;
